import { assign } from 'xstate';

import { type CustomizationMachineAction } from '../../types';

// ─────────────────────────────────────────────────────────────────────────────

export const storePendingAddToBag: CustomizationMachineAction = assign({
  shouldAddToBagWhenReady: true,
});
